var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.77624C21.7271 6.10418 20.8978 6.32658 20.0264 6.42587C20.9161 5.91571 21.5972 5.10654 21.92 4.1453C21.0854 4.61774 20.1642 4.96079 19.1826 5.14675C18.3966 4.34385 17.2785 3.84375 16.0384 3.84375C13.6593 3.84375 11.7303 5.69081 11.7303 7.9676C11.7303 8.29051 11.7683 8.6059 11.8418 8.90748C8.26201 8.73532 5.08768 7.09308 2.96314 4.59763C2.59176 5.20579 2.38049 5.91443 2.38049 6.67088C2.38049 8.10205 3.14161 9.36484 4.2964 10.1036C3.5904 10.081 2.92639 9.89507 2.34508 9.58596V9.63748C2.34508 11.6353 3.83056 13.3027 5.80024 13.6822C5.43936 13.7752 5.05882 13.8267 4.66514 13.8267C4.38696 13.8267 4.11794 13.8003 3.85417 13.75C4.40267 15.3898 5.99315 16.5822 7.87756 16.6149C6.40388 17.7206 4.54573 18.3778 2.52749 18.3778C2.17976 18.3778 1.83724 18.3576 1.5 18.3212C3.40671 19.4935 5.67036 20.1771 8.10327 20.1771C16.028 20.1771 20.3597 13.892 20.3597 8.44132L20.3453 7.90731C21.1917 7.32928 21.9239 6.60303 22.5 5.77624Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.14511ce21d4a740c39d86f3a18959719.svg";
export { ForwardRef as ReactComponent };